var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageHitSelectDrive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19.844mm",
    height: "15.119mm",
    viewBox: "0 0 19.844 15.119",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 4567h1280v-4567h-1280z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.20563 0 0 -.20563 -75.776 693.94)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(416.75 3374.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-7.559 0-13.786-6.227-13.786-13.785 0-5.951 3.86-11.085 9.191-12.996v-5.385h-29.869c-2.729 0-4.539-2.525-4.596-4.596v-9.98c-5.331-1.911-9.19-7.044-9.19-12.996 0-7.559 6.227-13.785 13.786-13.785s13.785 6.226 13.785 13.785c0 5.952-3.86 11.085-9.19 12.996v5.385h25.274v-5.385c-5.331-1.911-9.191-7.044-9.191-12.996 0-7.559 6.227-13.785 13.786-13.785s13.786 6.226 13.786 13.785c0 5.952-3.86 11.085-9.191 12.996v5.385h25.274v-5.385c-5.331-1.911-9.19-7.044-9.19-12.996 0-7.559 6.226-13.785 13.785-13.785s13.786 6.226 13.786 13.785c0 5.952-3.86 11.085-9.19 12.996v9.98c-1e-3 2.407-2.19 4.595-4.596 4.596h-29.869v5.385c5.331 1.911 9.191 7.045 9.191 12.996 0 7.558-6.227 13.785-13.786 13.785"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416.75 3365.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c2.592 0 4.595-2.003 4.595-4.595s-2.003-4.595-4.595-4.595-4.595 2.003-4.595 4.595 2.003 4.595 4.595 4.595",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(382.29 3319.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c2.592 0 4.595-2.003 4.595-4.596 0-2.591-2.003-4.594-4.595-4.594s-4.595 2.003-4.595 4.594c0 2.593 2.003 4.596 4.595 4.596",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416.75 3319.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c2.592 0 4.595-2.003 4.595-4.596 0-2.591-2.003-4.594-4.595-4.594s-4.595 2.003-4.595 4.594c0 2.593 2.003 4.596 4.595 4.596",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(451.21 3319.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c2.592 0 4.595-2.003 4.595-4.596 0-2.591-2.003-4.594-4.595-4.594s-4.595 2.003-4.595 4.594c0 2.593 2.003 4.596 4.595 4.596",
    style: {
      fill: "#fff"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageHitSelectDrive);
export default __webpack_public_path__ + "static/media/image_HitSelectDrive.430422d111f7f334346ce5524683c1c1.svg";
export { ForwardRef as ReactComponent };